import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ScreenSettingsService extends RestfulService<Models.LegacyScreenSetting> {

  constructor(private restService: RestService) {
    super(Models.LegacyScreenSetting);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('legacy-screen-settings');
  }

}
